var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-draggable-resizable",
    {
      attrs: {
        w: _vm.width,
        h: _vm.height,
        x: _vm.posX,
        y: _vm.posY,
        "min-height": 300,
        "min-width": _vm.minWidth,
        "max-width": 1400,
        active: true,
        parent: true,
        resizable: true,
        "class-name-handle": "object-form-resizable-handle",
        "drag-handle": ".drag",
        "data-app": ""
      },
      on: { dragstop: _vm.onDragStop, resizing: _vm.onResizing }
    },
    [
      _c(
        "v-layout",
        {
          ref: "objectForm",
          staticClass: "home-form-container elevation-2",
          style: {
            height: _vm.wasResized ? "100%" : "fit-content",
            maxHeight:
              _vm.tabs[_vm.activeTab] &&
              _vm.tabs[_vm.activeTab].label === "Photos"
                ? "100%"
                : "fit-content",
            height:
              _vm.tabs[_vm.activeTab] &&
              _vm.tabs[_vm.activeTab].code === "activities"
                ? "100%"
                : "fit-content"
          },
          attrs: { column: "" }
        },
        [
          _c(
            "form-header",
            {
              attrs: { title: _vm.pageTitle },
              on: { close: _vm.tryCloseForm }
            },
            [
              _c("form-options-menu", {
                attrs: {
                  "action-type": _vm.actionType,
                  "object-permission": _vm.permissionName,
                  "current-tab": _vm.tabs[_vm.activeTab]
                },
                on: {
                  changeViewModeOfObject: _vm.changeViewModeOfObject,
                  openDetails: function($event) {
                    return _vm.$emit("openDetails")
                  },
                  refresh: function($event) {
                    return _vm.$emit("refresh")
                  },
                  clearData: function($event) {
                    return _vm.$emit("clearData")
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          !_vm.loadingStructure
            ? _c(
                "v-tabs",
                {
                  key: _vm.openTabs + _vm.width,
                  attrs: {
                    value: _vm.activeTab,
                    "background-color": "transparent",
                    "show-arrows": "",
                    centered: "",
                    height: "40px",
                    "slider-color": "accent"
                  },
                  on: { change: _vm.changeTab }
                },
                _vm._l(_vm.tabs, function(tab, index) {
                  return _c(
                    "v-tab",
                    {
                      key: tab.code,
                      ref: "#" + index,
                      refInFor: true,
                      staticStyle: {
                        "text-transform": "none",
                        "font-size": "12px"
                      },
                      attrs: {
                        disabled:
                          !tab.enabled || !_vm.hasPermissionToSeeTab(tab)
                      }
                    },
                    [_vm._v("\n        " + _vm._s(tab.label) + "\n      ")]
                  )
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.loadingStructure
            ? _c(
                "div",
                { staticStyle: { position: "relative", height: "200px" } },
                [
                  _c("loading-spinner", {
                    attrs: {
                      active: _vm.loadingStructure,
                      "is-full-page": false,
                      color: "accent",
                      "background-color": "transparent"
                    },
                    on: {
                      "update:active": function($event) {
                        _vm.loadingStructure = $event
                      }
                    }
                  })
                ],
                1
              )
            : _c(
                "div",
                {
                  ref: "tabContainer",
                  staticClass: "home-form-tabs-container",
                  style: {
                    maxHeight:
                      _vm.tabs[_vm.activeTab] &&
                      _vm.tabs[_vm.activeTab].label === "Photos"
                        ? "80%"
                        : "65vh",
                    maxHeight:
                      _vm.tabs[_vm.activeTab] &&
                      _vm.tabs[_vm.activeTab].code === "activities"
                        ? "80%"
                        : "65vh"
                  }
                },
                [
                  _vm._t("formFields"),
                  _vm._v(" "),
                  _vm.tabs[_vm.activeTab] &&
                  _vm.tabs[_vm.activeTab].code === "activities"
                    ? _c("object-form-activities-tab", {
                        attrs: {
                          "object-uuid": _vm.objectUuid,
                          "object-layer": _vm.objectLayer,
                          "action-type": _vm.actionType,
                          "object-data": _vm.objectData,
                          width: _vm.width
                        }
                      })
                    : _vm._e()
                ],
                2
              ),
          _vm._v(" "),
          _c("v-flex", { attrs: { grow: "" } }),
          _vm._v(" "),
          !_vm.loadingStructure
            ? _c(
                "v-flex",
                { attrs: { shrink: "" } },
                [
                  _c(
                    "v-layout",
                    {
                      staticStyle: { width: "100%", padding: "0 20px" },
                      attrs: {
                        row: "",
                        "align-center": "",
                        "justify-space-between": ""
                      }
                    },
                    [
                      _c("form-required"),
                      _vm._v(" "),
                      !_vm.loadingStructure
                        ? _c(
                            "v-layout",
                            {
                              attrs: {
                                row: "",
                                "justify-space-between": !!_vm.$slots
                                  .footerButtons,
                                "justify-end": !_vm.$slots.footerButtons
                              }
                            },
                            [
                              _vm._t("footerButtons"),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _vm.activeTab > 0
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass: "footer-button mr-2",
                                          attrs: {
                                            text: "",
                                            color:
                                              "var(&#45;&#45;secondary-darker)"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.$emit(
                                                "updateActiveTab",
                                                _vm.activeTab - 1
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(_vm.$t("Previous")) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.activeTab < _vm.numberOfTabs - 1
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass: "footer-button mr-3",
                                          attrs: { color: "accent" },
                                          on: {
                                            click: function($event) {
                                              return _vm.$emit(
                                                "updateActiveTab",
                                                _vm.activeTab + 1
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(_vm.$t("Next")) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: {
                                        top: "",
                                        disabled:
                                          _vm.fieldsStillNeedFilled.length === 0
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(ref) {
                                              var on = ref.on
                                              return [
                                                _vm.actionType !== "view"
                                                  ? _c(
                                                      "v-btn",
                                                      _vm._g(
                                                        {
                                                          staticClass:
                                                            "footer-button",
                                                          class: {
                                                            disabled:
                                                              _vm.isSaveBtNdisabled
                                                          },
                                                          attrs: {
                                                            color: "accent",
                                                            loading:
                                                              _vm.loadingSave,
                                                            id: "save-button",
                                                            disabled:
                                                              _vm.isSaveBtNdisabled
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.$emit(
                                                                "save"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _vm._v(
                                                          "\n                  " +
                                                            _vm._s(
                                                              _vm.$t("Save")
                                                            ) +
                                                            "\n                "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        749126393
                                      )
                                    },
                                    [
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: { "text-align": "left" }
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.$t("MissingFields")) +
                                                ":"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.fieldsStillNeedFilled,
                                            function(field) {
                                              return _c("div", { key: field }, [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      "text-transform":
                                                        "capitalize",
                                                      "font-size": "12px"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(field) +
                                                        "\n                  "
                                                    )
                                                  ]
                                                )
                                              ])
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            2
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("dialogBox"),
      _vm._v(" "),
      _c("app-dialog-box", {
        attrs: {
          open: _vm.closeDialogIsOpen,
          title: _vm.$t("ClosingForm"),
          content:
            _vm.$t("UnsavedChanges") +
            "\n" +
            _vm.$t("CheckCloseForm") +
            "\n" +
            _vm.$t("ChangesWillBeLost"),
          "main-action-label": _vm.$t("No"),
          "secondary-action-label": _vm.$t("Yes")
        },
        on: {
          mainAction: function($event) {
            _vm.closeDialogIsOpen = false
          },
          secondaryAction: _vm.closeForm
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ca71506", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ca71506","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_Templates/DynamicObjectFormStructure.vue
// module id = null
// module chunks = 